import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heroTitleLead: {
    id: 'portal.views.cohorts.hero.titleLead',
    defaultMessage: 'Learn together',
    description: 'First part of the Cohorts page hero heading (italic eyebrow above "Cohorts")',
  },
  heroTitleCohorts: {
    id: 'portal.views.cohorts.hero.titleCohorts',
    defaultMessage: 'Cohorts',
    description: 'Second part of the Cohorts page hero heading',
  },
  heroSubtitle: {
    id: 'portal.views.cohorts.hero.subtitle',
    defaultMessage: 'Go through the course as a group with a facilitator. Discuss, reflect, and grow together.',
    description: 'Subtitle shown under the Cohorts page hero heading',
  },
  introTitle: {
    id: 'portal.views.cohorts.intro.title',
    defaultMessage: 'Better together',
    description: 'Cohorts page intro section title',
  },
  introText1: {
    id: 'portal.views.cohorts.intro.paragraph1',
    defaultMessage: 'Leadership is not a solo journey. The Leading with Character course is '
      + 'designed to be experienced together — with a group of peers who challenge, support, '
      + 'and inspire each other along the way. Whether you\'re part of a workplace team, a '
      + 'university cohort, or a community of friends, going through the course as a group '
      + 'deepens the learning and makes it stick.',
    description: 'Cohorts page intro paragraph 1',
  },
  introText2: {
    id: 'portal.views.cohorts.intro.paragraph2',
    defaultMessage: 'As a facilitator, you can create a cohort, invite your group, and guide '
      + 'them through all nine modules using our facilitator guide. Your cohort gets its own '
      + 'private discussion space where members can share reflections, prepare for group '
      + 'sessions, and connect with each other throughout the course.',
    description: 'Cohorts page intro paragraph 2',
  },
  guideCardTitle: {
    id: 'portal.views.cohorts.guide.title',
    defaultMessage: 'Facilitator Guide',
    description: 'Facilitator guide card title',
  },
  guideCardText: {
    id: 'portal.views.cohorts.guide.text',
    defaultMessage: 'Download the Facilitator Guide to learn how to set up and run a '
      + 'cohort, including tips for leading discussions and supporting your group.',
    description: 'Facilitator guide card description',
  },
  downloadPdfButton: {
    id: 'portal.views.cohorts.guide.downloadPdf',
    defaultMessage: 'Download PDF',
    description: 'Button to download the facilitator guide as a PDF',
  },
  downloadPptxButton: {
    id: 'portal.views.cohorts.guide.downloadPptx',
    defaultMessage: 'Download PowerPoint',
    description: 'Button to download the facilitator guide as a PowerPoint',
  },
  guideUnavailable: {
    id: 'portal.views.cohorts.guide.unavailable',
    defaultMessage: 'The Facilitator Guide is not available for download yet. Please check back later.',
    description: 'Empty state shown on the facilitator guide card when no guide file is available in any format, '
      + 'shown only to a signed-in visitor — a signed-out one sees guideSignInButton instead, since the guide '
      + 'availability check requires an account and cannot be resolved for them',
  },
  guideSignInButton: {
    id: 'portal.views.cohorts.guide.signInButton',
    defaultMessage: 'Sign in to download',
    description: 'Button shown on the facilitator guide card to a signed-out visitor, in place of the '
      + 'guide-unavailable message — the guide download requires an account, it is not actually unavailable',
  },
  guideDownloadError: {
    id: 'portal.views.cohorts.guide.downloadError',
    defaultMessage: 'The download failed. Please try again.',
    description: 'Inline error shown under the facilitator guide download buttons when a download fails',
  },
  startCardTitle: {
    id: 'portal.views.cohorts.start.title',
    defaultMessage: 'Start a Cohort',
    description: 'Start a cohort card title',
  },
  startCardText: {
    id: 'portal.views.cohorts.start.text',
    defaultMessage: 'Ready to lead a group through the course? Facilitators who have '
      + 'completed all six core modules and earned the final course completion certificate '
      + 'can start a cohort and invite others to join.',
    description: 'Start a cohort card description',
  },
  startCohortButton: {
    id: 'portal.views.cohorts.start.button',
    defaultMessage: 'Start a Cohort',
    description: 'Button label to start a cohort',
  },
  myCohortsButton: {
    id: 'portal.views.cohorts.start.myCohortsButton',
    defaultMessage: 'My Cohorts',
    description: 'Button shown on the start-a-cohort card to a signed-in user who belongs to at least one '
      + 'cohort in any role — it opens their only cohort, or the cohort list when there are several, and '
      + 'must not read as an invitation to start another one',
  },
  startCohortLockedHint: {
    id: 'portal.views.cohorts.start.lockedHint',
    defaultMessage: 'Complete the course to unlock this feature',
    description: 'Visible hint shown next to the disabled Start a Cohort button for a signed-in user who may not '
      + 'create cohorts yet; a signed-out visitor sees startCohortSignInButton instead',
  },
  startCohortSignInButton: {
    id: 'portal.views.cohorts.start.signInButton',
    defaultMessage: 'Sign in to start a cohort',
    description: 'Button shown on the start-a-cohort card to a signed-out visitor, in place of the '
      + 'disabled Start a Cohort button and its facilitator-eligibility tooltip — eligibility cannot '
      + 'be checked without an account, so this asks for the account first instead of reciting the '
      + 'requirements as though the visitor already had one',
  },
});

export default messages;
